export const TocNav = () => {
  (() => {
    const toc = document.querySelector(".js-tocnav ol");

    const setNav = () => {
      const content = document.querySelector(".p-single__main");
      const content_heading = content.querySelectorAll("h2");
      const heading_array = new Array(); //閲覧中の見出しを入れるための配列

      const nav = document.querySelector(".js-tocnav");

      // リストにリンク、タイトルを追加する
      // ---------------------------------------------------------
      content_heading.forEach((heading, index) => {
        if (index > 3) {
          return;
        }
        let text = heading.textContent;
        heading.setAttribute("id", "toc-" + index);

        let li = document.createElement("li");
        let link = document.createElement("a");
        link.textContent = text;
        link.setAttribute("href", `#toc-${index}`);

        li.appendChild(link);
        li.classList.add("h2");

        toc.appendChild(li);

        heading_array[`#toc-${index}`] = heading.offsetTop;
      });
    };

    window.addEventListener("DOMContentLoaded", () => {
      if (document.querySelector(".js-tocnav") != undefined) {
        setNav();
      }
    });
  })();
};
